<div class="tw-flex tw-flex-col tw-bg-white tw-rounded-lg tw-shadow-tb tw-p-5 tw-w-full tw-h-full">
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <div>
            <p class="tw-font-semibold tw-text-base">{{ 'interchain-dashboard.trends.title' | translate }}</p>
            <p class="tw-text-sm tw-italic" [ngClass]="{'tw-text-red-500': rankingPolarity === 'negative_count', 'tw-text-green-500': rankingPolarity === 'positive_count'}">
                {{ 'interchain-dashboard.trends.' + rankingPolarity | translate }}
            </p>
        </div>
        <div class="tw-cursor-pointer" (click)="getRankingTable.emit()">
            <i class="far fa-arrow-down" 
                [ngClass]="{'tw-text-red-500': rankingPolarity === 'negative_count', 'tw-text-green-500 tw-rotate-180': rankingPolarity === 'positive_count'}"
            >
            </i>
        </div>
    </div>

    @if (!loadingRankingTable) {
        <div class="tw-space-y-3">
            @if (rankingTableData?.pairs.length > 0) {
                @for (subtopic of rankingTableData?.pairs; track $index) {
                    <div class="tw-flex tw-items-center">
                        <span class="tw-text-sm tw-font-medium tw-mr-2">{{ $index + 1 }}.</span>
                        <span class="tw-flex-1">{{ subtopic.topic_translations | translateObject: 'name' | titlecase }} {{ subtopic.dimension_translations | translateObject: 'name' | titlecase }}</span>
                        <span class="tw-text-gray-500 tw-text-sm">({{ subtopic[rankingPolarity === 'negative_count' ? 'negative_mentions' : 'positive_mentions'] }})</span>
                    </div>
                }
            } @else {
                <p class="tw-text-center tw-text-gray-400 tw-text-sm tw-italic">{{ 'interchain-dashboard.widget_no_data' | translate }}</p>
            }
        </div>
    } @else {
        <div class="tw-flex tw-justify-center tw-items-center tw-h-full">
            <mh-core-lib-loader-wrapper [loading]="true" [type]="'spinner'"></mh-core-lib-loader-wrapper>
        </div>
    }

    <div class="tw-flex tw-justify-between tw-items-center tw-mt-5 tw-pt-4 tw-border-t tw-border-gray-100">
        <span class="tw-text-gray-400 tw-text-sm tw-italic tw-capitalize">{{ rankingTableData?.total_mentions }} {{ 'commons.mentions' | translate }}</span>
    </div>
</div>
